import { Typography } from '@mui/material';
import { StartupError } from './StartupError';

/** Rendered by `main.tsx` before the app boots, when the required `realm` query parameter is
 *  missing. */
export function MissingRealmError() {
  const expectedUrl = `${window.location.origin}${window.location.pathname}?realm=<realm-name>`;

  return (
    <StartupError title="Configuration Error">
      <Typography sx={{ mb: 3, lineHeight: 1.5 }}>
        Missing required <code>realm</code> query parameter.
      </Typography>
      <Typography sx={{ mb: 4, lineHeight: 1.5 }}>
        Expected URL format:
        <br />
        <code style={{ fontSize: '0.9em', wordBreak: 'break-all' }}>{expectedUrl}</code>
      </Typography>
      <Typography color="textSecondary" sx={{ fontSize: '0.9em', lineHeight: 1.5 }}>
        If you reached this page through a link, contact the application developer or your administrator.
      </Typography>
    </StartupError>
  );
}
